import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';
import { useStore } from 'hooks';
import { Button, Hint, message } from '../../ui';

export const MeterRobotButton = observer(() => {
  const { createRequest, meters, tenants, requests, houses, areas, callCard } =
    useStore();
  const navigate = useNavigate();

  const handleGoRobot = async (): Promise<void> => {
    const response = await callCard.goToRobot();

    if (!response) {
      message({
        type: 'error',
        text: 'Не удалось переключить жителя на телефонного робота',
      });
      return;
    }

    createRequest.clearCreateRequest(true);
    meters.clearAreaMeters();
    tenants.clearTenantStats();
    tenants.clearTenantSectors();
    requests.clearHistory();
    requests.clearCurrentSecondaryData();
    houses.clearHouseData();
    areas.clearAll();

    navigate('../list');

    message({
      type: 'success',
      text: 'Заявка отменена, житель переключен на телефонного робота',
    });
  };

  return (
    <Hint
      content={
        'Заявка отменится, а житель будет переключен на телефонного робота для сдачи показаний'
      }
    >
      <Button
        size="m"
        mode="neutral"
        variant="main"
        onClick={handleGoRobot}
        disabled={!callCard.activeCard?.id}
      >
        Переключить на работа для показаний
      </Button>
    </Hint>
  );
});
